import { ReactNode } from 'react';
import { Box } from '@mui/material';

export interface CalendarWithToolbarLayoutProps {
  toolbar: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}

const CalendarWithToolbarLayout = ({ toolbar, children, footer }: CalendarWithToolbarLayoutProps) => (
  <Box
    sx={{
      minHeight: 0,
      overflow: 'auto',
    }}
  >
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 999,
        flexShrink: 0,
        backgroundColor: 'background.paper',
      }}
    >
      {toolbar}
    </Box>
    <Box sx={{ minHeight: 0, overflow: 'auto' }}>{children}</Box>
    {footer}
  </Box>
);

export default CalendarWithToolbarLayout;
